// src/components/Footer.jsx

export default function Footer() {

  const scrollToSection = (id) => {
    if (typeof window === "undefined") return;
    const el = document.getElementById(id);
    if (!el) return;

    const navOffset = 80; 
    const y = el.getBoundingClientRect().top + window.scrollY - navOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const scrollToTop = () => {
    if (typeof window === "undefined") return;
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-zentra-gradient text-white">
      <div className="mx-auto max-w-7xl px-4 py-14">
        <div className="grid gap-10 md:grid-cols-3">
          {/* Columna: Datos */}
          <div>
            <h4 className="text-2xl font-semibold">Zentra Group</h4>
            <div className="mt-6 space-y-2 text-white/90">
              <p>
                <span className="font-semibold">Teléfono:</span> +569 68585106
              </p>
              <p>
                <span className="font-semibold">Correo:</span>{" "}
                <a
                  href="mailto:soporte@zentragroup.cl"
                  className="underline decoration-white/50 hover:text-white"
                >
                  soporte@zentragroup.cl
                </a>
              </p>
            </div>
          </div>

          {/* Columna: Links */}
          <div>
            <h5 className="text-xl font-semibold">Links</h5>
            <ul className="mt-4 space-y-2 text-white/90">
              <li>
                <button
                  type="button"
                  onClick={scrollToTop}
                  className="hover:text-white text-left"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => scrollToSection("nosotros")}
                  className="hover:text-white text-left"
                >
                  Nosotros
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => scrollToSection("servicios")}
                  className="hover:text-white text-left"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => scrollToSection("pricing")}
                  className="hover:text-white text-left"
                >
                  GPS
                </button>
              </li>
            </ul>
          </div>

          {/* Columna: Redes */}
          <div className="md:justify-self-end">
            <h5 className="text-xl font-semibold">Síguenos</h5>
            <div className="mt-4 flex gap-3">
              <a
                aria-label="Instagram"
                href="https://www.instagram.com/zentragroupcl/"
                className="grid h-10 w-10 place-items-center rounded-xl border border-white/25 bg-white/10 hover:bg-white/15"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm10 2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm-5 3a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 .001 6.001A3 3 0 0 0 12 9zm5.5-2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z" />
                </svg>
              </a>
              <a
                aria-label="Facebook"
                href="https://www.facebook.com/share/1Cqe4PgoRt/?mibextid=wwXIfr"
                className="grid h-10 w-10 place-items-center rounded-xl border border-white/25 bg-white/10 hover:bg-white/15"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2.2v-2.9h2.2V9.4c0-2.2 1.3-3.4 3.3-3.4.9 0 1.8.16 1.8.16v2h-1c-1 0-1.3.64-1.3 1.3v1.7h2.5l-.4 2.9h-2.1v7A10 10 0 0 0 22 12z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        
        <div className="mt-12 flex justify-center">
          <div className="rounded-full bg-white px-6 py-3 shadow-[0_10px_25px_rgba(0,0,0,.25)]">
            <span className="text-zentra-gradient font-semibold tracking-wide uppercase">
              Desarrollado por Zentra Group
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
